import cn from 'classnames';

import { hasItems } from 'src/utils/hasItems';

import { CoreGlobalNavigationFooterData } from 'src/types/components';

import ArrowForward from 'assets/icons/arrow-forward.svg';

import Link from 'components/BaseHelpers/Link';
import Text from 'components/BaseHelpers/Text';

import styles from './PrimaryGroups.module.scss';

export type PrimaryGroupsProps = {
  groups: CoreGlobalNavigationFooterData['fields']['primaryNavigationGroups'];
};

const PrimaryGroups = ({ groups }: PrimaryGroupsProps): JSX.Element => {
  const renderGroup = (group: PrimaryGroupsProps['groups'][number], index: number) => (
    <div key={index} className={styles['primary-group']}>
      <Text className={'body-eyebrow'} field={group.label} />
      <ul className={styles['group-listing']}>
        {group.listing.map((link, linkIndex) => (
          <li key={linkIndex} className={styles['listing-item']}>
            <Link
              href={link.href}
              url={link.url}
              openNewTab={link.target === '_blank'}
              className={cn(styles['listing-link'], 'body-sm', {
                [styles['wrappable']]: link.label.length > 20,
              })}
            >
              {link.label}
              <ArrowForward className={styles['arrow-icon']} />
            </Link>
            {hasItems(link.sublisting) && (
              <ul className={styles['sublisting']}>
                {link.sublisting?.map((sublink, sublinkIndex) => (
                  <li key={sublinkIndex} className={styles['sublisting-item']}>
                    <Link
                      href={sublink.href}
                      url={sublink.url}
                      openNewTab={sublink.target === '_blank'}
                      className={cn(styles['sublisting-link'], 'body-sm', {
                        [styles['wrappable']]: sublink.label.length > 20,
                      })}
                    >
                      {sublink.label}
                      <ArrowForward className={styles['arrow-icon']} />
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <div className={styles.main}>
      <div className={styles.mobile}>
        <div className={styles.left}>
          {groups.filter((_, index) => index % 2 === 0).map(renderGroup)}
        </div>
        <div className={styles.right}>
          {groups.filter((_, index) => index % 2 === 1).map(renderGroup)}
        </div>
      </div>
      <div className={styles.tablet}>
        <div className={styles.left}>
          {groups.filter((_, index) => index % 3 === 0).map(renderGroup)}
        </div>
        <div className={styles.middle}>
          {groups.filter((_, index) => index % 3 === 1).map(renderGroup)}
        </div>
        <div className={styles.right}>
          {groups.filter((_, index) => index % 3 === 2).map(renderGroup)}
        </div>
      </div>
      <div className={styles.desktop}>{groups.map(renderGroup)}</div>
    </div>
  );
};

export default PrimaryGroups;
